import { MARQUEE_WORDS } from "../data/site";

export const Marquee = ({ words = MARQUEE_WORDS, stroke = true, fast = false }) => {
  const row = [...words, ...words];
  return (
    <div className="relative overflow-hidden border-y border-line py-5 bg-base" data-testid="marquee">
      <div className={`flex whitespace-nowrap ${fast ? "animate-marquee-fast" : "animate-marquee"}`}>
        {row.map((w, i) => (
          <span
            key={i}
            className={`font-display text-5xl sm:text-7xl uppercase mx-6 leading-none ${
              stroke ? "text-stroke" : "text-harissa glow-harissa"
            }`}
          >
            {w}
            <span className="text-harissa mx-6">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
